// extracted by mini-css-extract-plugin
export default {"container":"styles_container__flWw7","contentContainer":"styles_contentContainer__vPPFf","PLTableTitle":"styles_PLTableTitle__2Xc3R","closePopupIcon":"styles_closePopupIcon__BSdgn"};